module.exports = __webpack_public_path__ + "img/salir.dedd7c7a.svg";